/**
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// react-router-dom components
import { Link } from "react-router-dom";

// @mui material components
import MuiBreadcrumbs from "@mui/material/Breadcrumbs";

// Material Kit 2 React components
import MKBox from "../../components/MKBox";
import MKTypography from "../../components/MKTypography";

function Breadcrumbs({ routes, ...rest }) {
  return (
    <MKBox borderRadius="md" sx={{ px: 2 }} width="100%">
      <MuiBreadcrumbs {...rest}>
        {routes.map(({ label, route }) =>
          route ? (
            <MKTypography
              key={label}
              component={Link}
              to={route}
              variant="button"
              fontWeight="medium"
              opacity={0.8}
              sx={{
                fontSize: { lg: "12px", xl: "14px", xxl: "16px", xxxl: "18px" },
                "&:hover, &:focus": {
                  color: ({ palette: { secondary } }) => secondary.main,
                },
              }}
            >
              {label}
            </MKTypography>
          ) : (
            <MKTypography
              key={label}
              variant="button"
              fontWeight="bold"
              sx={{
                fontSize: { lg: "12px", xl: "14px", xxl: "16px", xxxl: "18px" },
              }}
            >
              {label}
            </MKTypography>
          )
        )}
      </MuiBreadcrumbs>
    </MKBox>
  );
}

// Typechecking props for the Breadcrumbs
Breadcrumbs.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.shape).isRequired,
};

export default Breadcrumbs;
